import { computed, handleError, ref } from 'vue'
import { projectAuth, db } from '../firebase/config'
import { collection, query, where, getDocs } from "firebase/firestore";
import { user } from '../scripts/utils'
import { states } from '../main_store'
import router from '@/router';
import { handleErrors } from '@/views/views_functions/errorHandler';
// refs
// const user = ref(projectAuth.currentUser)

// auth changes
projectAuth.onAuthStateChanged(async (_user) => {
  if (_user) {
    console.log(_user);
    states.value.authPhoneNumber = _user.phoneNumber || null
    states.value.authEmail = _user.email || null
  }
  try {
    states.value.is_reload = true;
    if (_user && !user.value) {
      const q = query(collection(db, "users"), where("uid", "==", _user.uid));
      const querySnapshot = await getDocs(q);
      states.value.user = querySnapshot.docs.map(doc => doc.data())[0];

      if (states.value.user) {
        if (router.currentRoute.value.path !== '/privacy-policy') {
          states.value.is_reload = false;
          router.push({ name: "Home" });
        }
      } else {
        states.value.signup = true;
        states.value.is_reload = false;
        router.push({ name: "Signup" });
      }
    }

    states.value.is_reload = false;
  } catch (error) {
    states.value.is_reload = false;
    handleErrors(error)
    console.error("Error in onAuthStateChanged:", error);
  } finally {
    // Mark auth check as complete - this ensures loading screen shows until auth is determined
    states.value.authIsReady = true;
  }
});



const get_user = ref(computed(() => {
  return user.value
}))

const getUser = () => {
  return { user, get_user }
}

export default getUser